import {
  usePermissions,
  useRecordContext,
  useRedirect
} from 'react-admin';
import Button from "./button";
import IconEdit from '@mui/icons-material/Edit';

function EditCustomerPassportPhysicalButton()
{
  const { permissions } = usePermissions();
  const record = useRecordContext();
  const redirect = useRedirect();

  const btnClick = (e) =>
  {
    e.stopPropagation();
    redirect(('/customer-passport-physical/' + record.id));
  };

  if (permissions && permissions.is_master === true)
  {
    return (
      <Button label="Editar" color="info" onClick={btnClick}>
        <IconEdit />
      </Button>
    );
  }
  else
    return null;
}

export default EditCustomerPassportPhysicalButton;
